import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
const queryString = require('query-string')
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import Integrations from "../integration/Integrations.jsx";

class ConnectRedirect extends Component {

    constructor(props, context) {
        super(props, context)
        const uri = queryString.parse(this.props.location.search)

        if (!uri.response_type) {
            uri.response_type = 'code'
        }
        if (!uri.redirect_uri) {
            uri.redirect_uri = AppContext.getOptions().webCpqUrl + '/auth'
        }
        if (!uri.client_id) {
            const options = AppContext.getOptions()
            switch (options.environment) {
                case 'dev':
                    uri.client_id = 'web-cpq'
                    break
                case 'staging':
                    uri.client_id = 'staging-web-cpq'
                    break
                case 'release-candidate':
                    uri.client_id = 'rc-web-cpq'
                    break
                case 'prod':
                    uri.client_id = 'prod-web-cpq'
                    break
            }
        }

        this.state = {
            uri: uri,
            integrationKey: this.props.match.params.integrationKey,
        }
    }

    componentDidMount() {
        if (this.state.integrationKey.includes('shopify')) {
            this.handleShopifyConnect()
        } else {
            window.location = '/'
        }
    }

    handleShopifyConnect() {
        if (this.state.uri.shop) {
            window.location = AppContext.getOptions().apiUrl +
                `/openid/connect/${this.state.integrationKey}/${AppContext.getUserLoggedIn().id}?` +
                queryString.stringify(this.state.uri)
        }
    }

    render() {
        return <div className="text-center">
            <LoadingSpinner marginTop="20px" />
            <FormattedMessage
                id="signin.external.connect.loading"
                defaultMessage="Redirecting to {integrationName}..."
                values={{
                    integrationName: Integrations.getIntegrationNameFromKey(this.state.integrationKey)
                }}
            />
        </div>
    }

}

export default ConnectRedirect





// WEBPACK FOOTER //
// ./src/connect/connectredirect.component.jsx